import $ from 'jquery/$';
import CSP from 'csp/CSP';
import CSPT from 'csp/CSPT';

import React, { useEffect, useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';

import UsaAccordion from '@uswds/uswds/js/usa-accordion';
import UsaBanner from '@uswds/uswds/js/usa-banner';
import UsaCharacterCount from '@uswds/uswds/js/usa-character-count';
import UsaComboBox from '@uswds/uswds/js/usa-combo-box';
import UsaDatePicker from '@uswds/uswds/js/usa-date-picker';
import UsaDateRangePicker from '@uswds/uswds/js/usa-date-range-picker';
import UsaFileInput from '@uswds/uswds/js/usa-file-input';
import UsaInPageNavigation from '@uswds/uswds/js/usa-in-page-navigation';
import UsaInputMask from '@uswds/uswds/js/usa-input-mask';
import UsaModal from '@uswds/uswds/js/usa-modal';
import UsaRange from '@uswds/uswds/js/usa-range';
import UsaTable from '@uswds/uswds/js/usa-table';
import UsaTimePicker from '@uswds/uswds/js/usa-time-picker';
import UsaTooltip from '@uswds/uswds/js/usa-tooltip';
import UsaValidation from '@uswds/uswds/js/usa-validation';

CSP.Common = CSP.Common || {};

CSP.Common.isInIframe = function () {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

CSP.Common.executeFunction = function (name, args) {
  if (name === undefined || name === null) {
    return;
  }

  var funcParts = name.split('.');
  var func = window[funcParts[0]];
  for (var i = 1; i < funcParts.length; ++i) {
    if (func === undefined) {
      break;
    }
    func = func[funcParts[i]];
  }

  if (typeof func !== 'function') {
    return;
  }

  return func.apply(window, args);
};

CSP.Ajax = CSP.Ajax || {};

CSP.Ajax.fail = function (xhr) {
  var contentType = xhr.getResponseHeader('Content-Type');

  if (contentType != null && /^text\/html\b/i.test(contentType)) {
    document.open(contentType, 'replace');
    document.write(xhr.responseText);
    document.close();
    return false;
  }

  return true;
};

CSP.Valid = CSP.Valid || {};

CSP.Valid.init = function (id) {
  var idText = '';
  if (id !== undefined) {
    idText = '#' + id + ' ';
  }

  $(idText + "input[data-csp-valid='EmailAddress']").each(function () {
    $(this).attr('pattern', "^[a-zA-Z0-9!#$%&'*+\\/=?^_`\\{\\|\\}~\\-]+(?:\\.[a-zA-Z0-9!#$%&'*+\\/=?^_`\\{\\|\\}~\\-]+)*@(?!\\d+(\\.\\d+)*$)[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?)*$");
  });
};

CSP.PageLoader = CSP.PageLoader || {};

CSP.PageLoader._DEPTH = 0;

CSP.PageLoader.show = function () {
  var depth = CSP.PageLoader._getDepth();

  if (depth > 0) {
    CSP.PageLoader._setDepth(depth + 1);
    return true;
  }

  var overlayElement = CSP.PageLoader._getOverlayElement();

  if (overlayElement !== null) {
    overlayElement.style.display = 'block';
  }

  if (typeof CSPT !== 'undefined' && CSPT.killSessionTimerThenKeepAlive) {
    CSPT.killSessionTimerThenKeepAlive();
  }

  CSP.PageLoader._setDepth(1);

  return true;
};

CSP.PageLoader.hide = function () {
  var depth = CSP.PageLoader._getDepth();

  if (depth > 1) {
    CSP.PageLoader._setDepth(depth - 1);
    return true;
  }

  if (depth == 1) {
    var overlayElement = CSP.PageLoader._getOverlayElement();

    if (overlayElement !== null) {
      overlayElement.style.display = 'none';
    }

    if (typeof CSPT !== 'undefined' && CSPT.restartSessionTimer) {
      CSPT.restartSessionTimer();
    }
  }

  CSP.PageLoader._setDepth(0);

  return true;
};

CSP.PageLoader._getOverlayElement = function () {
  if (CSP.Common.isInIframe()) {
    return window.parent.CSP.PageLoader._getOverlayElement();
  }

  return document.getElementById('csp-page-loader-overlay');
};

CSP.PageLoader._getDepth = function () {
  if (CSP.Common.isInIframe()) {
    return window.parent.CSP.PageLoader._getDepth();
  }

  return CSP.PageLoader._DEPTH;
};

CSP.PageLoader._setDepth = function (depth) {
  if (CSP.Common.isInIframe()) {
    return window.parent.CSP.PageLoader._setDepth(depth);
  }

  CSP.PageLoader._DEPTH = depth;
  return;
};

CSP.Modal = CSP.Modal || {};

CSP.Modal._ID = null;
CSP.Modal._LOADED = false;
CSP.Modal._ONCLOSE_ARG = null;
CSP.Modal._ONCLOSE_ARGUMENTS = null;
CSP.Modal._ONCLOSE_FUNCTION_NAME = null;
CSP.Modal._SHOWN = false;

CSP.Modal.resize = function () {
  if (CSP.Common.isInIframe()) {
    return window.parent.CSP.Modal.resize();
  }

  if (CSP.Modal._ID !== null) {
    CSP.Modal._resize(CSP.Modal._ID);
  }

  return false;
};

CSP.Modal.bindButtons = function (id) {
  $('#' + id + ' a.csp-modal-button, #' + id + ' button.csp-modal-button').on('click', function (e) {
    CSP.Modal.onButtonClick(this);
  });
};

CSP.Modal.close = function () {
  if (CSP.Common.isInIframe()) {
    return window.parent.CSP.Modal.close.apply(window.parent, arguments);
  }

  if (CSP.Modal._ID !== null) {
    var oncloseArguments = Array.prototype.slice.call(arguments);
    $.merge(CSP.Modal._ONCLOSE_ARGUMENTS, oncloseArguments);
    $('#' + CSP.Modal._ID).find('.usa-modal__close').click();
  }

  return false;
};

CSP.Modal.onButtonClick = function (button) {
  var onclose = $(button).attr('data-onclose');
  var oncloseArg = $(button).attr('data-onclose-arg');
  var src = $(button).attr('data-src');
  var target = $(button).attr('data-target');

  var id;
  if (target.length > 1 && target.charAt(0) === '#') {
    id = target.substring(1);
  }
  else {
    id = null;
  }

  CSP.Modal._ID = id;
  CSP.Modal._LOADED = false;
  CSP.Modal._ONCLOSE_ARG = oncloseArg;
  CSP.Modal._ONCLOSE_ARGUMENTS = [id, oncloseArg];
  CSP.Modal._ONCLOSE_FUNCTION_NAME = onclose;
  CSP.Modal._SHOWN = false;

  $(target + ' iframe').attr('src', src);

  return false;
};

CSP.Modal.onClose = function () {
  try {
    $('#' + CSP.Modal._ID + ' iframe').attr('src', '');
    CSP.Common.executeFunction(CSP.Modal._ONCLOSE_FUNCTION_NAME, CSP.Modal._ONCLOSE_ARGUMENTS);
  }
  finally {
    CSP.Modal._dispose();
  }

  return false;
};

CSP.Modal.onLoaded = function (title) {
  if (CSP.Common.isInIframe()) {
    return window.parent.CSP.Modal.onLoaded(title);
  }

  if (CSP.Modal._ID !== null) {
    $('#' + CSP.Modal._ID + '_heading').text(title);

    if (CSP.Modal._SHOWN === true) {
      CSP.Modal._onDisplay(CSP.Modal._ID);
    }
  }

  CSP.Modal._LOADED = true;

  return false;
};

CSP.Modal.onShown = function () {
  if (CSP.Common.isInIframe()) {
    return window.parent.CSP.Modal.onShown();
  }

  if (CSP.Modal._ID !== null && CSP.Modal._LOADED === true) {
    CSP.Modal._onDisplay(CSP.Modal._ID);
  }

  CSP.Modal._SHOWN = true;

  return false;
};

CSP.Modal._onDisplay = function (id) {
  CSP.Modal._resize(CSP.Modal._ID);
  $('#' + id + ' .usa-modal__heading')[0].scrollIntoView(false);
  return;
};

CSP.Modal._resize = function (id) {
  var theIframe = $('#' + id + ' iframe')[0];
  theIframe.style.height = theIframe.contentWindow.document.body.scrollHeight + 'px';
  return;
};

CSP.Modal._dispose = function () {
  CSP.Modal._ID = null;
  CSP.Modal._LOADED = false;
  CSP.Modal._ONCLOSE_ARG = null;
  CSP.Modal._ONCLOSE_ARGUMENTS = null;
  CSP.Modal._ONCLOSE_FUNCTION_NAME = null;
  CSP.Modal._SHOWN = false;
  return;
};

CSP.Comp = CSP.Comp || {};

CSP.Comp._REFRESH_FUNCTION_MAP = {};

CSP.Comp._registerRefresh = function (id, refreshFunction) {
  CSP.Comp._REFRESH_FUNCTION_MAP[id] = refreshFunction;
  return;
};

CSP.Comp.refresh = function (id) {
  var refreshFunction = CSP.Comp._REFRESH_FUNCTION_MAP[id];
  if (refreshFunction === undefined || refreshFunction === null) {
    return false;
  }
  refreshFunction(id);
  return true;
};

CSP.Comp.Broadcast = CSP.Comp.Broadcast || {};

CSP.Comp.Broadcast.render = function (id, url) {
  const renderTemplate = <CspCompBroadcast id={ id } url={ url } />;
  const renderOptions = {identifierPrefix: id + '_'};
  const domNode = document.getElementById(id);
  const component = {
    root: createRoot(domNode)
  };
  component.root.render(renderTemplate, renderOptions);
  CSP.Comp._registerRefresh(id, function () {
    component.root.unmount();
    component.root = createRoot(domNode);
    component.root.render(renderTemplate, renderOptions);
    return;
  });
  return;
};

const CspCompBroadcast = function ({id, url}) {
  const [data, setData] = useState({});
  const [initialized, setInitialized] = useState(false);

  const rootRef = useRef();

  useEffect(() => {
    if (url) {
      async function fetchData () {
        $.post(url, function (response) {
          if (response && response.data) {
            setData(response.data);
          }
        }, 'json');
        return;
      }
      fetchData();
    }
    return;
  }, []);

  useEffect(() => {
    if (initialized === false && data.items) {
      const rootElement = rootRef.current;
      if (rootElement) {
        setInitialized(true);
        UsaModal.init(rootElement);
        return () => {
          UsaModal.teardown(rootElement);
        };
      }
    }
    return;
  }, [data]);

  return (
    <div ref={ rootRef }>
      {data.items && data.items.length > 0 && (
        <>
          <div className="usa-alert usa-alert--warning display-flex flex-align-center flex-justify padding-1 padding-left-2">
            <div className="display-flex flex-align-center">
              <div className="bg-gold padding-left-05 padding-y-05 margin-right-2 radius-md text-bold display-flex flex-align-center">
                <span className="font-sans-md padding-x-05">
                  {data.items.length}
                </span>
                <svg
                  className="usa-icon height-3 width-3 minh-3 minw-3 margin-right-1"
                  aria-hidden="true"
                  focusable="false"
                  role="img">
                  <use xlinkHref={ CSP.STATIC_EXT_PATH + '/uswds/3/img/sprite.svg#campaign' } />
                </svg>
              </div>
              <h4 className="usa-alert__heading padding-top-1 padding-right-2">
                {data.items[0].title}
              </h4>
              <p className="usa-alert__text">{data.items[0].desc}</p>
            </div>
            {data.items.length > 1 && (
            <button type="button" className="usa-button usa-button--unstyled position-relative margin-top-1" href={ '#' + id + '_modal' } data-open-modal aria-controls={ id + '_modal' }>View All Messages</button>
            )}
          </div>
          {data.items.length > 1 && (
          <div id={ id + '_modal' }
            class="usa-modal usa-modal--lg"
            aria-labelledby={ id + '_modal_heading' }
            aria-describedby={ id + '_modal_heading' }>
            <div class="usa-modal__content">
              <div class="usa-modal__main">
                <h2 id={ id + '_modal_heading' } class="usa-modal__heading">{ (data.items[0].appTypeCode && data.items[0].appTypeCode !== null) ? 'Application ' : '' }Broadcast Messages</h2>
                <div class="usa-prose">
                  {data.items && data.items.length > 0 && data.items.map((item) => (
                    <>
                      <h3>{item.title}</h3>
                      <p style={{wordWrap: 'break-word'}}>{item.desc}</p>
                    </>
                  ))}
                </div>
                <div class="usa-modal__footer">
                  <ul class="usa-button-group">
                    <li class="usa-button-group__item">
                      <button type="button" class="usa-button" data-close-modal>Close</button>
                    </li>
                  </ul>
                </div>
              </div>
              <button
                type="button"
                class="usa-button usa-modal__close"
                aria-label="Close this window"
                data-close-modal>
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlinkHref={ CSP.STATIC_EXT_PATH + '/uswds/3/img/sprite.svg#close' } />
                </svg>
              </button>
            </div>
          </div>
          )}
        </>
      )}
    </div>
  );
};

CSP.Comp.Document = CSP.Comp.Document || {};

CSP.Comp.Document.render = function (id, url) {
  const renderTemplate = <CspCompDocument id={ id } url={ url } />;
  const renderOptions = {identifierPrefix: id + '_'};
  const domNode = document.getElementById(id);
  const component = {
    root: createRoot(domNode)
  };
  component.root.render(renderTemplate, renderOptions);
  CSP.Comp._registerRefresh(id, function () {
    component.root.unmount();
    component.root = createRoot(domNode);
    component.root.render(renderTemplate, renderOptions);
    return;
  });
  return;
};

const CspCompDocument = function ({ id, url }) {

  function readableFileSize(size) {
    let units = ['KB', 'MB', 'GB'];
    let i = 0;
    size = size / 1024; // Input size is in bytes, the minimum unit to display on UI is KB.
    while(size >= 1024 && i < 2) {
        size = size / 1024;
        i++;
    }
    return (Math.ceil(size * 10) / 10) + ' ' + units[i];
  }

  const [data, setData] = useState({});
  
  useEffect(() => {
    if (url) {
      async function fetchData () {
        $.post(url, function (response) {
          if (response && response.data) {
            setData(response.data);
          }
        }, 'json');
        return;
      }
      fetchData();
    }
    return;
  }, []);

  return (
    <div className="border-accent-cool-darker border-2px radius-lg margin-bottom-5">
      <h3 className="site-preview-heading margin-top-0 margin-bottom-0 bg-accent-cool-darker text-white padding-x-2 padding-y-1">
        Guides &amp; Resources
      </h3>
      <div className="maxh-card-lg overflow-x-hidden csp-resource-tile">
        <ul className="usa-collection usa-collection--condensed padding-x-2">
        {data.items && data.items.length > 0 && data.items.map((item) => (
          <li key={item.title} className="usa-collection__item border-0 margin-top-1px padding-top-1px">
            <div className="usa-collection__body">
              <h4 className="usa-collection__heading">
                <a className="usa-link" href= { item.url} >
                  { item.title } [ 
                    { item.fileType }{ item.fileSize ? ", " + readableFileSize(item.fileSize) : ""}
                    ]
                </a>
              </h4>
              <p className="usa-collection__description margin-top-1px">{ item.desc }</p>
            </div>
          </li>
        ))}
        </ul>
      </div>
    </div>
  );
};

CSP.Comp.QuickLink = CSP.Comp.QuickLink || {};

CSP.Comp.QuickLink.renderSecure = function (id, url) {
  const renderTemplate = <CspCompQuickLinkSecure id={ id } url={ url } />;
  const renderOptions = {identifierPrefix: id + '_'};
  const domNode = document.getElementById(id);
  const component = {
    root: createRoot(domNode)
  };
  component.root.render(renderTemplate, renderOptions);
  CSP.Comp._registerRefresh(id, function () {
    component.root.unmount();
    component.root = createRoot(domNode);
    component.root.render(renderTemplate, renderOptions);
    return;
  });
  return;
};

const CspCompQuickLinkSecure = function ({ id, url }) {
  const [data, setData] = useState({});
  const [initialized, setInitialized] = useState(false);

  const rootRef = useRef();

  useEffect(() => {
    if (url) {
      async function fetchData () {
        $.post(url, function (response) {
          if (response && response.data) {
            setData(response.data);
          }
        }, 'json');
        return;
      }
      fetchData();
    }
    return;
  }, []);

  return (
    <div className="border-accent-cool-darker border-2px radius-lg">
      <h3 className="site-preview-heading margin-top-0 margin-bottom-0 bg-accent-cool-darker text-white padding-x-2 padding-y-1">Helpful Links</h3>
      <div className="maxh-card-lg overflow-x-hidden csp-resource-tile">
        <ul className="usa-collection usa-collection--condensed padding-x-2">
        {data.items && data.items.length > 0 && data.items.map((item) => (
          <li key={item.title} className="usa-collection__item border-0 margin-top-1px padding-top-1px">
            <div className="usa-collection__body">
              <h4 className="usa-collection__heading">
                <a className="usa-link usa-link--external" href= { item.url} target="_blank" rel="noopener noreferrer">{ item.title }</a>
              </h4>
              <p className="usa-collection__description margin-top-1px">{ item.desc }</p>
            </div>
          </li>
        ))}
        </ul>
      </div>
    </div>
  );
};

CSP.Comp.Spotlight = CSP.Comp.Spotlight || {};

CSP.Comp.Spotlight.renderSecure = function (id, url) {
  const renderTemplate = <CspCompSpotlightSecure id={ id } url={ url } />;
  const renderOptions = {identifierPrefix: id + '_'};
  const domNode = document.getElementById(id);
  const component = {
    root: createRoot(domNode)
  };
  component.root.render(renderTemplate, renderOptions);
  CSP.Comp._registerRefresh(id, function () {
    component.root.unmount();
    component.root = createRoot(domNode);
    component.root.render(renderTemplate, renderOptions);
    return;
  });
  return;
};

const CspCompSpotlightSecure = function ({id, url}) {
  const [data, setData] = useState({});
  const [initialized, setInitialized] = useState(false);

  const rootRef = useRef();

  useEffect(() => {
    if (url) {
      async function fetchData () {
        $.post(url, function (response) {
          if (response && response.data) {
            setData(response.data);
          }
        }, 'json');
        return;
      }
      fetchData();
    }
    return;
  }, []);

  useEffect(() => {
    if (initialized === false && data.items) {
      const rootElement = rootRef.current;
      if (rootElement) {
        setInitialized(true);
        UsaModal.init(rootElement);
        return () => {
          UsaModal.teardown(rootElement);
        };
      }
    }
    return;
  }, [data]);

  return (
    <div ref={ rootRef }>
      {data.items && data.items.length > 0 && (
        <>
          <div className="usa-alert usa-alert--info display-flex flex-align-center flex-justify padding-1 padding-left-2 bg-accent-cool-lighter">
            <div className="display-flex flex-align-center">
              <div className="bg-accent-cool padding-left-05 padding-y-05 margin-right-2 radius-md text-bold display-flex flex-align-center">
                <span className="font-sans-md padding-x-05">
                  {data.items.length}
                </span>
                <svg
                  className="usa-icon height-3 width-3 minh-3 minw-3 margin-right-1"
                  aria-hidden="true"
                  focusable="false"
                  role="img">
                  <use xlinkHref={ CSP.STATIC_EXT_PATH + '/uswds/3/img/sprite.svg#lightbulb_outline' } />
                </svg>
              </div>
              <h4 className="usa-alert__heading padding-top-1 padding-right-2">
                {data.items[0].title}
              </h4>
              <p className="usa-alert__text">{data.items[0].descPlainText} &nbsp;
              {data.items[0].url && (
                <a href= {data.items[0].url}  className="usa-link" title={ data.items[0].urlDesc} target="_blank" rel="noopener noreferrer">More Information</a>
              )}
              </p>
            </div>
            {data.items.length > 1 && (
              <button type="button" className="usa-button usa-button--unstyled" href={ '#' + id + '_modal' } data-open-modal aria-controls={ id + '_modal' }>View All Messages</button>
            )}
          </div>
          {data.items.length > 1 && (
          <div id={ id + '_modal' }
          className="usa-modal usa-modal--lg"
            aria-labelledby={ id + '_modal_heading' }
            aria-describedby={ id + '_modal_heading' }>
            <div className="usa-modal__content">
              <div className="usa-modal__main">
                <h2 id={ id + '_modal_heading' } className="usa-modal__heading">In the Spotlight Messages</h2>
                <div className="usa-prose">
                  {data.items && data.items.length > 0 && data.items.map((item) => (
                    <>
                      <h3>{item.title}</h3>
                      <p style={{wordWrap: 'break-word'}}>{item.descPlainText} &nbsp;
                        {item.url && (
                          <a href= {item.url}  className="usa-link" title={ item.urlDesc} target="_blank" rel="noopener noreferrer">More Information</a>
                        )}
                      </p>
                    </>
                  ))}
                </div>
                <div className="usa-modal__footer">
                  <ul className="usa-button-group">
                    <li className="usa-button-group__item">
                      <button type="button" className="usa-button" data-close-modal>Close</button>
                    </li>
                  </ul>
                </div>
              </div>
              <button
                type="button"
                className="usa-button usa-modal__close"
                aria-label="Close this window"
                data-close-modal>
                <svg className="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlinkHref={ CSP.STATIC_EXT_PATH + '/uswds/3/img/sprite.svg#close' } />
                </svg>
              </button>
            </div>
          </div>
          )}
        </>
      )}
    </div>
  );
};

CSP.Comp.User = CSP.Comp.User || {};

CSP.Comp.User.renderMenuApplicationsSecure = function (id, url) {
  const renderTemplate = <CspCompUserMenuApplicationsSecure id={ id } url={ url } />;
  const renderOptions = {identifierPrefix: id + '_'};
  const domNode = document.getElementById(id);
  const component = {
    root: createRoot(domNode)
  };
  component.root.render(renderTemplate, renderOptions);
  CSP.Comp._registerRefresh(id, function () {
    component.root.unmount();
    component.root = createRoot(domNode);
    component.root.render(renderTemplate, renderOptions);
    return;
  });
  return;
};

const CspCompUserMenuApplicationsSecure = function ({id, url}) {
  const [data, setData] = useState({});
  const [initialized, setInitialized] = useState(false);

  const rootRef = useRef();

  useEffect(() => {
    if (url) {
      async function fetchData () {
        $.post(url, function (response) {
          if (response && response.data) {
            setData(response.data);
          }
        }, 'json');
        return;
      }
      fetchData();
    }
    return;
  }, []);

  useEffect(() => {
    if (initialized === false && data.items) {
      const rootElement = rootRef.current;
      if (rootElement) {
        setInitialized(true);
        UsaTooltip.init(rootElement);
      }
    }
    return;
  }, [data]);

  function getSelectedAppName(data) {
    var selectedAppName = '--Select Application--';
    if (data.selectedAppTypeCode && data.items) {
      for (var i = 0; i < data.items.length; ++i) {
        var item = data.items[i];
        if (data.selectedAppTypeCode === item.appTypeCode) {
          selectedAppName = item.appName;
          break;
        }
      }
    }
    return selectedAppName;
  }

  return (
    <div ref={ rootRef }>
      <button
        type="button"
        class="usa-accordion__button usa-nav__link usa-current"
        aria-expanded="false"
        aria-controls="basic-nav-section-one">
        <span>{ getSelectedAppName(data) }</span>
      </button>
      <ul id="basic-nav-section-one" class="usa-nav__submenu" hidden>
        {data.items && data.items.filter(
          item => !(data.selectedAppTypeCode &&
            data.selectedAppTypeCode === item.appTypeCode)).map((item) => (
        <li class="usa-nav__submenu-item">
          <a
            href={ item.appUrl }
            class="usa-tooltip"
            data-position="right"
            data-classes=""
            title={ item.appDesc }
          >{ item.appName }</a>
        </li>
        ))}
      </ul>
    </div>
  );
};

CSP.Comp.User.renderMenuCommunicationCenterSecure = function (id, url) {
  const renderTemplate = <CspCompUserMenuCommunicationCenterSecure id={ id } url={ url } />;
  const renderOptions = {identifierPrefix: id + '_'};
  const domNode = document.getElementById(id);
  const component = {
    root: createRoot(domNode)
  };
  component.root.render(renderTemplate, renderOptions);
  CSP.Comp._registerRefresh(id, function () {
    component.root.unmount();
    component.root = createRoot(domNode);
    component.root.render(renderTemplate, renderOptions);
    return;
  });
  return;
};

const CspCompUserMenuCommunicationCenterSecure = function ({id, url}) {
  const [data, setData] = useState({});

  useEffect(() => {
    if (url) {
      async function fetchData () {
        $.post(url, function (response) {
          if (response && response.data) {
            setData(response.data);
          }
        }, 'json');
        return;
      }
      fetchData();
    }
    return;
  }, []);

  if (data.appName && data.appUrl) {
    return (
      <li class="usa-nav__secondary-item">
        <a href={ data.appUrl }>{ data.appName }</a>
      </li>
    );
  }

  return null;
};

CSP.Comp.User.renderMenuSsnOrCaseSearchSecure = function (id, url, actionUrl, csrfParameterName, csrfToken) {
  const renderTemplate = <CspCompUserMenuSsnOrCaseSearchSecure id={ id } url={ url } actionUrl={ actionUrl } csrfParameterName={ csrfParameterName } csrfToken={ csrfToken } />;
  const renderOptions = {identifierPrefix: id + '_'};
  const domNode = document.getElementById(id);
  const component = {
    root: createRoot(domNode)
  };
  component.root.render(renderTemplate, renderOptions);
  CSP.Comp._registerRefresh(id, function () {
    component.root.unmount();
    component.root = createRoot(domNode);
    component.root.render(renderTemplate, renderOptions);
    return;
  });
  return;
};

const CspCompUserMenuSsnOrCaseSearchSecure = function ({id, url, actionUrl, csrfParameterName, csrfToken}) {
  const [data, setData] = useState({});
  const [initialized, setInitialized] = useState(false);

  const rootRef = useRef();
  
  useEffect(() => {
    if (url) {
      async function fetchData () {
        $.post(url, function (response) {
          if (response?.data) {
            setData(response.data);
          }
        }, 'json');
        return;
      }
      fetchData();
    }
    return;
  }, []);

  useEffect(() => {
    if (initialized === false && data.appUrl) {
      const rootElement = rootRef.current;
      if (rootElement) {
        setInitialized(true);
        UsaInputMask.init(rootElement);
      }
    }
    return;
  }, [data]);

  if (data?.appUrl) {
    return (
      <div ref={ rootRef }>
      <form className="usa-form csp-ssn-form bg-base-lightest" action={ actionUrl } method="post" autoComplete="off" name="searchForm">
        <label className="usa-label margin-top-0 font-sans-3xs" htmlFor="ssn">SSN</label>
        <input type="text" id="ssn" inputMode="numeric" name="ssn" placeholder="___ __ ____"
               pattern="^\d{3} \d{2} \d{4}$" className="usa-input usa-masked bg-white height-4" />
        <div className="grid-col-auto display-flex flex-align-center csp-ssn-form-or-text">OR</div>
        <label className="usa-label margin-top-0 font-sans-3xs" htmlFor="csp-search-case-field">Case ID</label>
        <input className="usa-input border-right height-4 csp-ssn-form-search-case-field" id="csp-search-case-field"
               type="search" name="caseId" maxLength="15" />
        <button className="usa-button csp-ssn-form-search-button" type="submit">
          <span className="usa-search__submit-text">Search</span>
          <img src={ CSP.STATIC_EXT_PATH + '/uswds/3/img/usa-icons-bg/search--white.svg' }
                className="usa-search__submit-icon" alt="Search" />
        </button>
        <input type="hidden" name="appUrl" value={ data.appUrl } />
        { csrfParameterName !== null && csrfParameterName.trim() != '' &&
          <input type="hidden" name={ csrfParameterName } value={ csrfToken } />
        }
      </form>
      <div class="bg-base-lightest width-full font-sans-3xs margin-top-1">
      Results are limited to responses received within the last 30 days.
      </div>
      </div>
    );
  }

  return null;
};

CSP.Comp.User.renderNameSecure = function (id, url) {
  const renderTemplate = <CspCompUserNameSecure id={ id } url={ url } />;
  const renderOptions = {identifierPrefix: id + '_'};
  const domNode = document.getElementById(id);
  const component = {
    root: createRoot(domNode)
  };
  component.root.render(renderTemplate, renderOptions);
  CSP.Comp._registerRefresh(id, function () {
    component.root.unmount();
    component.root = createRoot(domNode);
    component.root.render(renderTemplate, renderOptions);
    return;
  });
  return;
};

const CspCompUserNameSecure = function ({id, url}) {
  const [data, setData] = useState({});

  useEffect(() => {
    if (url) {
      async function fetchData () {
        $.post(url, function (response) {
          if (response && response.data) {
            setData(response.data);
          }
        }, 'json');
        return;
      }
      fetchData();
    }
    return;
  }, []);

  if (data.userFirstName && data.userLastName) {
    return (
      <>Welcome, { data.userFirstName } { data.userLastName }</>
    );
  }

  return null;
};

var CspUsaTable = {};

CspUsaTable.init = function (root) {
  UsaTable.init(root);
  $(root).find(UsaTable.SORTABLE_HEADER).each(function () {
    $(this).attr('aria-label', $(this).attr('aria-label').replace(/\s+/g, ' '));
    $(this).find(UsaTable.SORT_BUTTON).each(function () {
      $(this).attr('title', $(this).attr('title').replace(/\s+/g, ' '));
    });
  });
  return;
};

const USWDS_COMPONENT_INIT_LIST = [
  UsaAccordion.init,
  UsaBanner.init,
  UsaCharacterCount.init,
  UsaComboBox.init,
  UsaDatePicker.init,
  UsaDateRangePicker.init,
  UsaFileInput.init,
  UsaInPageNavigation.init,
  UsaInputMask.init,
  UsaModal.init,
  UsaRange.init,
  [UsaTable.TABLE, CspUsaTable.init],
  UsaTimePicker.init,
  UsaTooltip.init,
  UsaValidation.init
];

const USWDS_COMPONENT_TEARDOWN_LIST = [
  UsaFileInput.teardown,
  UsaModal.teardown
];

CSP.Partial = CSP.Partial || {};

CSP.Partial.init = function (root) {
  USWDS_COMPONENT_INIT_LIST.forEach((component) => {
    var selector = null;
    var func = component;
    if (Array.isArray(component)) {
      selector = component[0];
      func = component[1];
    }
    if (selector !== null) {
      $(root).find(selector).each(function () {
        func(this);
      });
    }
    else {
      func(root);
    }
  });
  return;
};

CSP.Partial.dispose = function (root) {
  USWDS_COMPONENT_TEARDOWN_LIST.forEach((component) => {
    var selector = null;
    var func = component;
    if (Array.isArray(component)) {
      selector = component[0];
      func = component[1];
    }
    if (selector !== null) {
      $(root).find(selector).each(function () {
        func(this);
      });
    }
    else {
      func(root);
    }
  });
  return;
};

CSP.Partial.render = function (id, url, data = null, callback = null) {
  if (data === null) {
    data = {};
  }
  CSP.PageLoader.show();
  $.post(url, data, function (html) {
    const element = document.getElementById(id);
    CSP.Partial.dispose(element);
    $('#' + id).html(html);
    CSP.Partial.init(element);
    if (callback !== null) {
      callback(element);
    }
  }, 'html').fail(function (xhr) {
    CSP.Ajax.fail(xhr);
  }).always(function (xhr) {
    CSP.PageLoader.hide();
  });
  return;
};

CSP.USA = CSP.USA || {};

CSP.USA.Accordion = CSP.USA.Accordion || {};

CSP.USA.Accordion.collapseAll = function (root = 'body') {
  $(root + " " + UsaAccordion.BUTTON).each(function () {
    UsaAccordion.toggle(this, false);
  });
  return;
};

CSP.USA.Accordion.expandAll = function (root = 'body') {
  $(root + " " + UsaAccordion.BUTTON).each(function () {
    UsaAccordion.toggle(this, true);
  });
  return;
};
